import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-scroll';



const Container = styled.div`
    color: #fff;
    background: ${({lightBg}) => (lightBg ? '#fff' : '#010606')};

    @media screen and (max-width: 768px) {
        padding: 100px 0;
    }
`
const Wrapper = styled.div`
    display: grid;
    z-index: 1;
    height: 650px;
    width: 100%;
    max-width: 1100px;
    margin-right: auto;
    margin-left: auto;
    padding: 0 24px;
    justify-content: center;
`
const Row = styled.div`
    display:grid;
    grid-auto-columns: minmax(auto, 1fr);
    align-items: center;
    grid-template-areas: ${({imgStart}) => (imgStart ? `'col2 col1'` : `'col1 col2'`)};

    @media screen and (max-width: 768px){
        grid-template-areas: ${({imgStart}) => (imgStart ? `'col1' 'col2'` : `'col1 col1' 'col2 col2'`)}
    }
`
const Column1 = styled.div`
    margin-bottom: 15px;
    padding: 0 15px;
    grid-area: col1;
`
const Column2 = styled.div`
    margin-bottom: 15px;
    margin-left: 50px;
    padding: 0 15px;
    grid-area: col2;
`
const TextWrapper = styled.div`
    max-width: 540px;
    padding-top: 0;
    padding-bottom: 60px;
`
const TopLine = styled.p`
    color: #01bf71;
    font-size: 16px;
    line-height: 16px;
    font-weight: 700;
    letter-spacing: 1.4px;
    text-transform: uppercase;
    margin-bottom: 16px;
`
const Heading = styled.h1`
    margin-bottom: 24px;
    font-size: 48px;
    line-height: 1.1;
    font-weight: 600;
    color: ${({lightText}) => (lightText ? '#f7f8fa' : '#010606')};

    @media screen and (max-width: 560px) {
        font-size: 32px;
    }
`
const Subtitle = styled.div`
    max-width: 440px;
    margin-bottom: 35px;
    font-size: 18px;
    line-height: 24px;
    color: ${({darkText}) => (darkText ? '#010606' : '#fff' )};
`
const BtnWrap = styled.div`
    display: flex;
    justify-content: flex-start;
`
const Btn = styled(Link)`
    border-radius: 50px;
    background: ${({primary}) =>(primary) ? '#fff' : '#8a65f0'};
    color: ${({dark}) => (dark ? '#000' : '#fff' )};
    white-space: nowrap;
    padding: 14px 48px;
    font-size: 20px;
    outline: none;
    border: none;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: all 0.2s ease-in-out;

    &:hover {
        transition: all 0.2s ease-in-out;
        background : #cebfff;
        color: #000
    }

    @media screen and (max-width:786px){
        padding: 12px 30px;
        font-size: 16px;
    }
`
const ImgWrap = styled.div`
    max-width: 550px;
    height: 100%;
    @media screen and (max-width:786px){
        max-width: 400px;
        margin: 0 auto;
    }
`
const Img = styled.img`
    width: 100%;
    margin: 0 0 10px 0;
    padding-right: 0;
`
const Layout = ({lightBg,id,imgStart,topLine,headLine,lightText,darkText,description,buttonLabel,img,alt,headTo,primary,dark}) => {
    return (
        <>
        <Container lightBg={lightBg} id={id}>
            <Wrapper>
                <Row imgStart={imgStart}>
                    <Column1>
                        <TextWrapper>
                            <TopLine>{topLine}</TopLine>
                            <Heading lightText={lightText}>{headLine}</Heading>
                            <Subtitle darkText={darkText}>{description}</Subtitle>
                            <BtnWrap>
                                <Btn to={headTo} spy={true} smooth={true} duration={1000} offset={-110} primary={primary ? 1 : 0} dark={dark ? 1 : 0} >{buttonLabel}</Btn>
                            </BtnWrap>
                        </TextWrapper>
                    </Column1>
                    <Column2>
                        <ImgWrap>
                            <Img src={img} alt={alt} />
                        </ImgWrap>
                    </Column2>
                </Row>
            </Wrapper>
        </Container>
        </>
    )
}

export default Layout;